import type { ResolvedMonospaceSpace } from '#layers/data-model/public';
import { createContext } from 'reka-ui';

export interface UpdateSpaceRoutesOptions {
	spaces: ResolvedMonospaceSpace[];
	/** Skip refreshing the current route when updating records during navigation. */
	skipCurrentRouteUpdate?: boolean;
}

export interface SpaceRouteUpdates {
	updateRoutes: (options: UpdateSpaceRoutesOptions) => { revert: () => void };
}

export const [useUpdateSpaceRoutes, provideSpaceRouteUpdates] = createContext<SpaceRouteUpdates>('SpaceRoutes');
